import React from 'react';
import './CaseStudies.css';

const CaseStudies = () => {
  const cases = [
    {
      title: 'WAREHOUSE SAFETY SIMULATOR',
      goal: 'help new staff understand risks on day one.',
      description: 'We recreated a full warehouse workflow in VR — movement, equipment use, hazard spotting.',
      result: 'employees learn safe behavior through practice, not lectures.',
      image: '/images/g1.jpg'
    },
    {
      title: 'FIRE SAFETY SIMULATOR',
      goal: 'teach calm, correct actions during emergencies.',
      description: 'Users train with realistic fire dynamics, alarms, and extinguishers.',
      result: 'people react faster and make fewer critical mistakes.',
      image: '/images/g2.jpg'
    },
    {
      title: 'MEDICAL OPERATION PREP',
      goal: 'standardize pre-op training.',
      description: 'Trainees walk through each step of a procedure, repeat as needed, and build confidence.',
      result: 'better consistency and readiness.',
      image: '/images/g3.jpg'
    },
    {
      title: 'VIRTUAL CHEMISTRY MUSEUM',
      goal: 'improve engagement and learning outcomes through interactive, scalable education.',
      description: 'A virtual chemistry museum turns complex topics into clear, visual experiences through interactive exhibits and guided exploration.',
      result: 'deeper understanding, higher engagement, and better knowledge retention.',
      image: '/images/about-img.jpg'
    }
  ];

  return (
    <div className="container-fluid fh5co-content-box" id="case-studies-wrapper">
      <div className="container-fluid px-5">
        <div id="case-studies">
          <div className="row">
            <div className="col-12">
              <div className="quote-box2 wow bounceInDown" data-wow-delay=".15s">
                <h2 style={{color: '#ff6600'}}>CASE STUDIES</h2>
              </div>
            </div>
          </div>
          {/* First row with 2 cards */}
          <div className="row align-items-start">
            {cases.slice(0, 2).map((caseItem, index) => (
              <div key={index} className="col-lg-6 d-flex flex-column">
                {index === 0 ? (
                  <>
                <div 
                      className={`case-study-item position-relative wow bounceInUp`} 
                  data-wow-delay={`${0.1 + index * 0.05}s`}
                      style={{overflow: 'hidden'}}
                >
                  {caseItem.title === 'WAREHOUSE SAFETY SIMULATOR' ? (
                    <div className="video-container" style={{
                      aspectRatio: '16/9',
                      width: '100%',
                      position: 'relative',
                      overflow: 'hidden'
                    }}>
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/BPoVcJPjBbg"
                        title="Warehouse Safety Simulator"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%'
                        }}
                      ></iframe>
                    </div>
                  ) : (
                    <div 
                      className="case-media w-100 h-100" 
                      style={{
                        background: `url('${caseItem.image}') center center/cover no-repeat`
                      }}
                    ></div>
                  )}
                    </div>
                    <div className="case-text-wrapper">
                      <div className="case-text-content">
                        <h3 className="text-white mb-3" style={{margin: 0, padding: 0, lineHeight: '1.2', fontSize: '1.5rem', fontWeight: 'bold'}}>{caseItem.title}</h3>
                        <p className="mb-2">
                          <strong>GOAL:</strong> {caseItem.goal}
                        </p>
                        <p className="mb-3">{caseItem.description}</p>
                        <p className="mb-0">
                          <strong>RESULT:</strong> {caseItem.result}
                        </p>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="case-text-wrapper">
                      <div className="case-text-content">
                        <h3 className="text-white mb-3" style={{margin: 0, padding: 0, lineHeight: '1.2', fontSize: '1.5rem', fontWeight: 'bold'}}>{caseItem.title}</h3>
                        <p className="mb-2">
                      <strong>GOAL:</strong> {caseItem.goal}
                    </p>
                        <p className="mb-3">{caseItem.description}</p>
                        <p className="mb-0">
                      <strong>RESULT:</strong> {caseItem.result}
                    </p>
                  </div>
                    </div>
                    <div 
                      className={`case-study-item position-relative wow bounceInUp`} 
                      data-wow-delay={`${0.1 + index * 0.05}s`}
                      style={{overflow: 'hidden'}}
                    >
                      {caseItem.title === 'FIRE SAFETY SIMULATOR' ? (
                        <div className="video-container" style={{
                          aspectRatio: '16/9',
                          width: '100%',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/hTYoxzqGSTU"
                            title="Fire Safety Simulator"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%'
                            }}
                          ></iframe>
                        </div>
                      ) : (
                        <div 
                          className="case-media w-100 h-100" 
                          style={{
                            background: `url('${caseItem.image}') center center/cover no-repeat`
                          }}
                        ></div>
                      )}
                </div>
                  </>
                )}
              </div>
            ))}
          </div>
          {/* Second row with 2 cards */}
          <div className="row align-items-start" style={{marginTop: '1rem'}}>
            {cases.slice(2, 4).map((caseItem, index) => (
              <div key={index + 2} className="col-lg-6 d-flex flex-column">
                {index === 0 ? (
                  <>
                <div 
                      className={`case-study-item position-relative wow bounceInUp`} 
                      data-wow-delay={`${0.3 + index * 0.05}s`}
                      style={{overflow: 'hidden'}}
                >
                  {caseItem.title === 'MEDICAL OPERATION PREP' ? (
                    <div className="video-container" style={{
                      aspectRatio: '16/9',
                      width: '100%',
                      position: 'relative',
                      overflow: 'hidden'
                    }}>
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/iov0jLsTCv8"
                        title="Medical Operation Prep"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%'
                        }}
                      ></iframe>
                    </div>
                  ) : (
                    <div 
                      className="case-media w-100 h-100" 
                      style={{
                        background: `url('${caseItem.image}') center center/cover no-repeat`
                      }}
                    ></div>
                  )}
                    </div>
                    <div className="case-text-wrapper">
                      <div className="case-text-content">
                        <h3 className="text-white mb-3" style={{margin: 0, padding: 0, lineHeight: '1.2', fontSize: '1.5rem', fontWeight: 'bold'}}>{caseItem.title}</h3>
                        <p className="mb-2">
                          <strong>GOAL:</strong> {caseItem.goal}
                        </p>
                        <p className="mb-3">{caseItem.description}</p>
                        <p className="mb-0">
                          <strong>RESULT:</strong> {caseItem.result}
                        </p>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="case-text-wrapper">
                      <div className="case-text-content">
                        <h3 className="text-white mb-3" style={{margin: 0, padding: 0, lineHeight: '1.2', fontSize: '1.5rem', fontWeight: 'bold'}}>{caseItem.title}</h3>
                        <p className="mb-2">
                      <strong>GOAL:</strong> {caseItem.goal}
                    </p>
                        <p className="mb-3">{caseItem.description}</p>
                        <p className="mb-0">
                      <strong>RESULT:</strong> {caseItem.result}
                    </p>
                  </div>
                    </div>
                    <div 
                      className={`case-study-item position-relative wow bounceInUp`} 
                      data-wow-delay={`${0.3 + index * 0.05}s`}
                      style={{overflow: 'hidden'}}
                    >
                      {caseItem.title === 'VIRTUAL CHEMISTRY MUSEUM' ? (
                        <div className="video-container" style={{
                          aspectRatio: '16/9',
                          width: '100%',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/qjTTUUpM9cI"
                            title="Virtual Chemistry Museum"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%'
                            }}
                          ></iframe>
                        </div>
                      ) : (
                        <div 
                          className="case-media w-100 h-100" 
                          style={{
                            background: `url('${caseItem.image}') center center/cover no-repeat`
                          }}
                        ></div>
                      )}
                </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseStudies;

